import { Flex } from "components/Flex";
import { useBrushes } from "hooks/BrushesProvider";
import React, { useCallback, useState } from "react";
import { useSettings } from "Settings";
import styled from "styled-components";
import { AikaDate } from "utils/AikaDate";
import { BrushSelect } from "../BrushSelect";
import { MoveDirection, useCalendar } from "../CalendarProvider";
import { ScheduleBlock } from "../ScheduleBlock";
import { Toolbox } from "../Toolbox";
import { BlockDetails } from "./BlockDetails";
import BlockDisplay from "./BlockDisplay";
import { DateSelect } from "./DateSelect";
import { DayColumn } from "./DayColumn";
import { TimeColumn } from "./TimeColumn";

const Container = styled.div``;

const MOBILE_UNIT_HEIGHT = 45;

export const MobileCalendar = () => {
  const [startDate, setStartDate] = useState(AikaDate.today());
  const [settings] = useSettings();
  const brushes = useBrushes();
  const calendar = useCalendar(startDate, 1);
  const [activeBlock, setActiveBlock] = useState<string | null>(null);
  const [activeBrush, setActiveBrush] = useState<string>("color-1");

  const block = calendar.blocks.find((x) => x.id === activeBlock);

  const { resizeBlock } = calendar;

  const deleteActiveBlock = () => {
    const id = activeBlock;
    setActiveBlock(null);
    calendar.deleteBlock(id);
  };

  const updateBlock = ({ description, color, tags }) => {
    calendar.updateBlock(activeBlock, {
      description,
      color,
      tags,
    });
  };

  const cancelUpdate = () => {
    calendar.rollback();
    setActiveBlock(null);
  };

  const onConfirm = () => {
    calendar.commit();
    setActiveBlock(null);
  };

  const createBlock = (start: number) => {
    if (activeBlock != null) {
      setActiveBlock(null);
      calendar.commit();
    } else {
      let description = "";
      let col = 0;
      let tags = [];

      if (activeBrush.startsWith("color")) {
        col = parseInt(activeBrush.split("-")[1]);
      } else {
        const brush = brushes.brushes.find((x) => x.id === activeBrush);
        description = brush.description;
        col = brush.color;
        tags = brush.tags;
      }

      console.log(startDate);
      console.log(startDate.toString());

      const newBlock = ScheduleBlock.createNew(
        description,
        start,
        col,
        startDate,
        tags
      );
      calendar.addBlock(newBlock);
      setActiveBlock(newBlock.id);
    }
  };

  const handleResize = useCallback(
    (edge: MoveDirection, startOrLength: number) => {
      resizeBlock(activeBlock, edge, "normal", startOrLength);
    },
    [resizeBlock, activeBlock]
  );

  return (
    <Container>
      <Toolbox>
        <DateSelect value={startDate} onChange={setStartDate} />
        <BrushSelect value={activeBrush} onChange={setActiveBrush} />
      </Toolbox>
      <Flex>
        <TimeColumn
          unitHeight={MOBILE_UNIT_HEIGHT}
          start={settings.startOfDay}
          end={settings.endOfDay}
        />
        <DayColumn
          day={startDate}
          start={settings.startOfDay}
          end={settings.endOfDay}
          unitHeight={MOBILE_UNIT_HEIGHT}
          onClick={(ev) => createBlock(ev.slot)}
        >
          {calendar.blocks
            .filter((x) => x.isOnDay(startDate))
            .map((x) => (
              <BlockDisplay
                key={x.id}
                id={x.id}
                onSelect={setActiveBlock}
                start={x.start}
                length={x.length}
                color={x.color}
                tags={x.tags}
                description={x.description}
                unitHeight={MOBILE_UNIT_HEIGHT}
                active={activeBlock === x.id}
                onResize={handleResize}
                onResizeEnd={calendar.commitAction}
              />
            ))}
        </DayColumn>
      </Flex>
      {block && (
        <BlockDetails
          description={block.description}
          color={block.color}
          tags={block.tags}
          onChange={updateBlock}
          onDelete={deleteActiveBlock}
          onCancel={cancelUpdate}
          onConfirm={onConfirm}
        />
      )}
    </Container>
  );
};
